import GakkiApp from 'app/gakki';
import GakkiManagementApp from './app/gakki-management';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import React, {useEffect} from 'react';
import {DateTime} from 'luxon';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';
import {ToastContainer} from 'react-toastify';

function MicrosoftIdentityLogin() {
  useEffect(() => {
    const expireDate = DateTime.now().plus({days: 10});
    document.cookie = `fake-cookie=fake-cookie;expires=${expireDate.toHTTP()};same-site=none;path=/`;
    window.location.href = '/';
  }, []);
  return <div>Fake</div>;
}

export const client = new QueryClient();
client.setDefaultOptions({
  queries: {
    refetchOnWindowFocus: false,
    retry: 1,
  },
});

export default function App() {
  const fakeADLogin =
    (process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'test') &&
    window.location.host.indexOf('localhost') > -1;
  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Router>
        <Switch>
          <Route path={'/gakki'}>
            <GakkiApp />
          </Route>
          <Route path={'/gakki-management'}>
            <GakkiManagementApp />
          </Route>
          {fakeADLogin && (
            <Route path={'/MicrosoftIdentity/Account/SignIn'} key={'login'}>
              <MicrosoftIdentityLogin />
            </Route>
          )}
          <Redirect from={'/'} to={'/gakki-management'} />
        </Switch>
      </Router>
      <ToastContainer
        hideProgressBar={false}
        pauseOnFocusLoss={false}
        draggable={false}
      />
    </QueryClientProvider>
  );
}
